export type FeatureArea = "design-canvas" | "photoshoot" | "training" | "techpack" | "studio" | "tryon" | "auth" | "team" | "trends" | "assets" | "billing" | "media" | "unknown";

export const inferFeatureArea = (requestPath?: string): FeatureArea => {
  if (!requestPath) return "unknown";

  if (/users\/(otp|login)|\/sso\/|\/auth\//.test(requestPath)) return "auth";
  if (requestPath.includes("tryon")) return "tryon";
  if (requestPath.includes("mannequin") || requestPath.includes("ghost") || requestPath.includes("photoshoot") || requestPath.includes("start_photoshooting")) return "photoshoot";
  if (requestPath.includes("studio")) return "studio";
  if (requestPath.includes("train")) return "training";
  if (requestPath.includes("techpack") || requestPath.includes("tech-pack") || requestPath.includes("vector")) return "techpack";
  if (requestPath.includes("trend") || requestPath.includes("brand-dna") || requestPath.includes("fabric-dna")) return "trends";
  if (requestPath.includes("team")) return "team";
  if (requestPath.includes("payments") || requestPath.includes("subscription") || requestPath.includes("credit")) return "billing";
  if (requestPath.includes("asset") || requestPath.includes("product")) return "assets";
  if (requestPath.includes("design")) return "design-canvas";

  return "unknown";
};
